import muster from '@dbk-legacy/muster';
import { variable } from '@dbk-legacy/muster/helpers';
import { call } from '@dbk-legacy/muster/utils';
import isValidJsonString from '../utils/is-valid-json-string';
import { getValues, ref } from '@dbk-legacy/muster/utils';
import { encode } from 'base-64';

export default () =>{
  return muster()
    
    .path('marque.getMarqueData', { 
      call: async ({ req }, { get, set, call }) => {
        let channel = 'web';
        const [oMarqueStr] =
          await getValues(get(`roster.ebanking.marque.getMarqueData.${channel}`));
          isValidJsonString(oMarqueStr).then((data) => {
            const response = data;
            if((response.channel.toUpperCase() == "ALL")|| (response.channel.toUpperCase() == "WEB")){
              set('marque.loginDissmiss', false);
              set('marque.marqueData',response);
            } else {
              set('marque.loginDissmiss', true);
              set('marque.marqueData',"");
            }
          }).catch((error) => {
              set('marque.loginDissmiss', true);
              set('marque.marqueData',"");
          });
      },
    })

    .path('marque.callLoginDissMiss', { 
      call: async ({ req }, { get, set, call }) => {
        set('marque.loginDissmiss', true);
      },
    })

    .path('marque.getAllMarqueData', { 
      call: async ({ req }, { get, set, call }) => {
        let ran_str = "random" + Math.round(Math.random() * 1000);
        // set('marque.allMarqueData',"");
        let channel = 'ALL';
        const [oMarqueStr] =
          await getValues(get([
            `roster.data.marque.getAllMarqueData.${channel}.${ran_str}`
            ]));
          isValidJsonString(oMarqueStr).then((data) => {
            set('marque.allMarqueData',data);
          }).catch((error) => {
              set('marque.allMarqueData',"");
          });
      },
    })

    .path('marque.editMarque', { 
      call: async ({ req }, { get, set, call }) => {
        set('marque.editMarqueData', req.args[0]);
      },
    })

    .path('marque.saveMarqueData', { 
      call: async ({ req }, { get, set, call }) => {
        let marqueStr = req.args[0];
        // let marqueStrArray = JSON.stringify(marqueStr).replace(/\'/g, "\"");
        let marqueStrArray = JSON.stringify(marqueStr);
        const oMarqueStr = encode(marqueStrArray);
        console.log("hi marquee",oMarqueStr);
        const [oSaveMarqueStr] =
          await getValues(get(`roster.data.marque.saveMarqueData.["${oMarqueStr}"]`));

          isValidJsonString(oSaveMarqueStr).then(async(data) => {
            const [messages] = await getValues(get('i18n.messages'));

            switch(data.savedRetCode){
              case 0:
                alert(messages['app.marque.msgSuccess'])
                set('marque.editMarqueData', "");
                call("marque.getAllMarqueData");
                call('ui.history.replace', { pathname: '/admin/alertlist' });
                break;
              case 1:
                alert(messages['app.marque.unExpectederror'])
                set('marque.editMarqueData', "");
                call('ui.history.replace', { pathname: '/admin/alertlist' });
                break;
              case 2:
                alert(messages['app.marque.alredyExistingMsg'])
                set('marque.editMarqueData', "");
                call('ui.history.replace', { pathname: '/admin/alertlist' });
                break;
              default:
                alert(messages['app.marque.unExpectederror'])
                set('marque.editMarqueData', "");
                call('ui.history.replace', { pathname: '/admin/alertlist' });
                break;
            } 
          }).catch((error) => {
            console.log(error);
          });
      },
    })
    .path('marque.editMarqueData',variable(""))

    .path('marque.allMarqueData',variable(""))

    .path('marque.loginDissmiss', variable(true))
    .path('marque.marqueData', variable());

}